import {
    GET_GENERIC_MESSAGE_LIST,
    GET_GENERIC_MESSAGE_LIST_SUCCESS,
  
    SAVE_GENERIC_MESSAGE_MASTER,
    SAVE_GENERIC_MESSAGE_SUCCESS,
  
    EDIT_GENERIC_MESSAGE,
    EDIT_GENERIC_MESSAGE_SUCCESS,
  
    UPDATE_GENERIC_MESSAGE,
    UPDATE_GENERIC_MESSAGE_SUCCESS,
  
    DELETE_GENERIC_MESSAGE,
    DELETE_GENERIC_MESSAGE_SUCCESS,
  
    GENERIC_MESSAGE_ERROR_ACTION,
    RESET_GENERIC_MESSAGE_STATE
  } from "./actionType";
  
  
  // 🔹 Get List
  
  export const getGenericMessageList = (config = {}) => ({
    type: GET_GENERIC_MESSAGE_LIST,
    config,
  });
  
  
  export const getGenericMessageListSuccess = (pages) => ({
    type: GET_GENERIC_MESSAGE_LIST_SUCCESS,
    payload: pages,
  });
  
  
  // 🔹 Save
  export const saveGenericMessage = (config = {}) => ({
    type: SAVE_GENERIC_MESSAGE_MASTER,
    config,
  });
  
  export const saveGenericMessageSuccess = (resp) => ({
    type: SAVE_GENERIC_MESSAGE_SUCCESS,
    payload: resp,
  });
  
  
  // 🔹 Edit
  export const editGenericMessage = (config = {}) => ({
    type: EDIT_GENERIC_MESSAGE,
    config,
  });
  
  export const editGenericMessageSuccess = (resp) => ({
    type: EDIT_GENERIC_MESSAGE_SUCCESS,
    payload: resp,
  });
  
  
  // 🔹 Update
  export const updateGenericMessage = (config = {}) => ({
    type: UPDATE_GENERIC_MESSAGE,
    config,
  });
  
  export const updateGenericMessageSuccess = (resp) => ({
    type: UPDATE_GENERIC_MESSAGE_SUCCESS,
    payload: resp,
  });
  
  
  // 🔹 Delete
  export const deleteGenericMessage = (config = {}) => ({
    type: DELETE_GENERIC_MESSAGE,
    config,
  });
  
  export const deleteGenericMessageSuccess = (resp) => ({
    type: DELETE_GENERIC_MESSAGE_SUCCESS,
    payload: resp,
  });

  // 🔹 Reset (on List page leave)
export const resetGenericMessageState = () => ({
  type: RESET_GENERIC_MESSAGE_STATE,
});

  
  
  // 🔹 Error
  export const GenericMessageErrorAction = () => ({
    type: GENERIC_MESSAGE_ERROR_ACTION,
  });
  